import React from 'react'
import styles from './Checkbox.module.css'

function checkbox({id, value, setValue }) {
    return (
        <div className={styles.container}>
            <div className={styles.round}>
                <input id={id} type="checkbox" checked={value} onChange={(e) => {setValue(e.target.checked)}} />
                <label for={id}></label>
            </div>
        </div>
    )
}

export default checkbox